
const KSTypography = ({
    className,
}) => {
    
    return (
        
        <div id="KSTypography" className={className}>
            
            <header>
                <h3>Typography</h3>
            </header>
            
            <section className="headers">
                <h1>H1</h1>
                <h2>H2</h2>
                <h3>H3</h3>
                <h4>H4</h4>
                <h5>H5</h5>
                <h6>H6</h6>
            </section>
            
            <section>
                <p className="text-xs">text-xs</p>
                <p className="text-sm">text-sm</p>
                <p className="text-base">text-base</p>
                <p className="text-lg">text-lg</p>
                <p className="text-xl">text-xl</p>
                <p className="text-2xl">text-2xl</p>
                <p className="text-3xl">text-3xl</p>
                <p className="text-4xl">text-4xl</p>
                <p className="text-5xl">text-5xl</p>
                <p className="text-6xl">text-6xl</p>
                <p className="text-7xl">text-7xl</p>
                <p className="text-8xl">text-8xl</p>
                <p className="text-9xl">text-9xl</p>
            </section>
        
        </div>
        
    )
    
}

export default KSTypography
